module.exports = [{
      plugin: require('/home/benjamin/workspace/inno-websites-gdpr/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-W9WK65S","includeInDevelopment":false},
    },{
      plugin: require('/home/benjamin/workspace/inno-websites-gdpr/packages/site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
